import Constants from "../Base/Constants";
import GrimoireInterface from "../Interface/GrimoireInterface";
import Attribute from "./Attribute";
import NSDictionary from "../Base/NSDictionary";
import NSIdentity from "../Base/NSIdentity";
import IdResolver from "../Base/IdResolver";
import Component from "./Component";
import Ensure from "../Base/Ensure";
export default class ComponentDeclaration {
    constructor(name, _ctorOrObj, _super) {
        this.name = name;
        this._ctorOrObj = _ctorOrObj;
        this.idResolver = new IdResolver();
        this._resolvedDependency = false;
        if (!_super) {
            this.resolveDependency();
            return;
        }
        if (_super instanceof NSIdentity || typeof _super === "string") {
            this._super = _super;
        }
        else {
            this.superComponent = _super;
        }
    }
    get isDependenyResolved() {
        return this._resolvedDependency;
    }
    generateInstance(componentElement) {
        if (!this.isDependenyResolved) {
            this.resolveDependency();
        }
        componentElement = componentElement ? componentElement : document.createElementNS(this.name.ns.qualifiedName, this.name.name);
        const component = new this.ctor();
        componentElement.setAttribute(Constants.x_gr_id, component.id);
        GrimoireInterface.componentDictionary[component.id] = component;
        component.name = this.name;
        component.element = componentElement;
        component.attributes = new NSDictionary();
        for (let key in this.attributes) {
            Attribute.generateAttributeForComponent(key, this.attributes[key], component);
        }
        return component;
    }
    resolveDependency() {
        if (this._resolvedDependency) {
            return false;
        }
        const attr = {};
        let dec;
        if (this._super || this.superComponent) {
            const id = this._super ? Ensure.tobeNSIdentity(this._super) : this.superComponent["name"];
            dec = GrimoireInterface.componentDeclarations.get(id);
            dec.resolveDependency();
            for (let key in dec.attributes) {
                attr[key] = dec.attributes[key];
                this.idResolver.add(NSIdentity.fromFQN(this.name.fqn + "." + key));
            }
            this.superComponent = dec.ctor;
        }
        this.ctor = this._ensureTobeComponentConstructor(this.name, this._ctorOrObj, dec ? dec.ctor : void 0);
        for (let key in this.ctor.attributes) {
            attr[key] = this.ctor.attributes[key];
            this.idResolver.add(NSIdentity.fromFQN(this.name.fqn + "." + key));
        }
        this.attributes = attr;
        ComponentDeclaration.ctorMap.push({ ctor: this._ctorOrObj, name: this.name });
        return this._resolvedDependency = true;
    }
    /**
     * Ensure the given object or constructor to be an constructor inherits Component;
     * @param  {Object | (new ()=> Component} obj [The variable need to be ensured.]
     * @return {[type]}      [The constructor inherits Component]
     */
    _ensureTobeComponentConstructor(id, obj, baseConstructor) {
        if (typeof obj === "function") {
            const inheritsAttr = this._extractInheritsAttributes(obj);
            if (baseConstructor) {
                const newCtor = function () {
                    baseConstructor.call(this);
                    obj.call(this);
                };
                const proto = this._clonePrototypeChain(obj.prototype, baseConstructor.prototype);
                newCtor.prototype = proto;
                newCtor.prototype["name"] = id;
                newCtor.attributes = inheritsAttr;
                return newCtor;
            }
            else {
                obj.prototype["name"] = id;
                obj.attributes = inheritsAttr;
                return obj;
            }
        }
        else {
            if (baseConstructor && !(baseConstructor.prototype instanceof Component) && baseConstructor !== Component) {
                throw new Error("Base component comstructor must extends Compoent class.");
            }
            const ctor = baseConstructor || Component;
            const newCtor = function () {
                ctor.call(this);
            };
            obj.__proto__ = ctor.prototype;
            newCtor.prototype = obj;
            newCtor.attributes = obj.attributes;
            newCtor.prototype["name"] = id;
            return newCtor;
        }
    }
    _extractInheritsAttributes(ctor) {
        const attrs = [];
        while (ctor) {
            if (ctor === Component) {
                break;
            }
            attrs.push(ctor.attributes);
            ctor = ctor.prototype.__proto__.constructor;
        }
        const atr = {};
        for (let i = attrs.length - 1; i >= 0; i--) {
            for (let key in attrs[i]) {
                atr[key] = attrs[i][key];
            }
        }
        return atr;
    }
    _clonePrototypeChain(obj, base) {
        const chain = [];
        let c = obj;
        while (true) {
            if (c.constructor === Component) {
                break;
            }
            chain.push(c);
            c = Object.getPrototypeOf(c);
        }
        chain.reverse();
        chain.pop();
        let ret = base;
        for (let i = 0; i < chain.length; i++) {
            const props = Object.getOwnPropertyDescriptors(chain[0]);
            ret = Object.create(ret, props);
        }
        obj.__proto__ = ret;
        return obj;
    }
}
ComponentDeclaration.ctorMap = [];



// WEBPACK FOOTER //
// ./src/Node/ComponentDeclaration.ts